import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "aria-label", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(_ctx.buttonClass),
    title: _ctx.label,
    "aria-label": _ctx.label,
    disabled: _ctx.disabled || _ctx.loading
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(['bi', _ctx.icon])
        }, null, 2))
  ], 10, _hoisted_1))
}